<section class="generic-navbar-spacer">
    <div class="divider">
        <section class="call-section container-fluid py-2rem">
            <div class="call-content-wrap">
                <router-outlet></router-outlet>
            </div>
        </section>
    </div>
</section>